import { render, staticRenderFns } from "./ElMobileSuggestions.vue?vue&type=template&id=73627f84"
import script from "./ElMobileSuggestions.vue?vue&type=script&lang=js"
export * from "./ElMobileSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports